/*
 * @Author: your name
 * @Date: 2021-12-16 11:36:50
 * @LastEditTime: 2022-01-05 16:32:41
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \BusinessSystem\src\hooks\initStyle.ts
 */
import { themeList } from "../plugins/themeVariable";

const theme = "simple";
export function initStyle(t) {
  if (t === undefined) {
    t = window.localStorage.getItem("themeId") || "simple";
    if (themeList[t] === undefined) {
      t = theme;
    }
  }
  const colors = themeList[t];

  localStorage.setItem("themeId", t);

  Object.keys(colors).forEach(key => {
    const colorKey = key;
    const colorValue = colors[key];
    document.documentElement.style.setProperty(colorKey, colorValue);
  });
}
